import axios from 'axios';

import {
  REMOVE_EMPLOYEE_NOTES,
  REQUEST_ADD_NOTE,
  REQUEST_NOTES
} from 'RestAPIs/endpoints';

export interface RequestNotesProps {
  content: string;
  creationDate: string;
  creationEmployeeNumber: number;
  creationUser: string;
  flags: string[];
  noteId: number;
  refId: number;
  type: string;
}

export interface NoteContent {
  content: string;
  flags?: string[];
  refId?: number;
}

export interface NewRequestNote {
  body: NoteContent | { note: NoteContent };
}

export const getRequestNotes = (requestId: number) =>
  axios.get<RequestNotesProps[]>(REQUEST_NOTES, {
    pathParams: { requestId }
  });

export const addRequestNote = ({ body }) =>
  axios.post<NewRequestNote>(REQUEST_ADD_NOTE, body);

export const removeRequestNote = (noteId: number) =>
  axios.delete(REMOVE_EMPLOYEE_NOTES, {
    pathParams: { noteId }
  });
